const languages = [
  { code: "en", name: "English", flag: "GB" },
  { code: "es", name: "Español", flag: "ES" },
  { code: "fr", name: "Français", flag: "FR" },
  { code: "de", name: "Deutsch", flag: "DE" },
  { code: "pt", name: "Portugues", flag: "PT" },
  { code: "br", name: "Brasileiro", flag: "BR" },
  { code: "it", name: "Italiano", flag: "IT" },
  { code: "th", name: "\u0E44\u0E17\u0E22", flag: "TH" },
  { code: "ua", name: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430", flag: "UA" },
  { code: "by", name: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F", flag: "BChB" },
  { code: "mt", name: "Malti", flag: "MT" },
]

const defaultLanguage = "en"

const languageCodes = languages.map(l => l.code)

module.exports = { languages, defaultLanguage, languageCodes }
